<template>
<div>
    <div class="mcc-dialog-overlay">
        <dialog class="mcc-dialog mu-overflow-visible mcc-dialog--primary mcc-dialog--xs" id="delegatedialog" ref="delegatedialog">
            <form novalidate id="delegateFormId" ref="delegateFormRef">
                <section>
                    <div class="mcc-dialog__header">
                        <h2 class="h4">Select an assignee</h2>
                        <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="delegateCloseHandler()">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                    </div>
                    <div class="mcc-dialog__body mu-overflow-visible">
                        <div class="mcc-row">
                            <div class="mcc-col">
                                <div style="position:relative">
                                    <div v-if="!updateCall" class="spinner-overlay">
                                        <div class="spinner-background"></div>
                                        <div class="spinner-flex">
                                            <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                                <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                                <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                            </svg>
                                        </div>
                                    </div>
                                    <div class="mfc-slim-select-wrapper mu-position-relative dialogSlimSelect mfc-form-input-container mu-gap-00 input-gap" id="InvolvingselectIdDiv" v-show="selectUpdated">
                                        <label for="assigneeField" class="mfc-label--required">Assignee</label>
                                        <div id="InvolvingselectIdDiv"></div>
                                        <select class="mfc-slim-select" aria-label="single_radio_input" :value="delegateAssignee" @change="delegateAssignee = $event.target.value" required ref="delegateassigneeselect" id="assigneeField" name="assignee" block>
                                
                                        </select>
                                    </div>
                                    <div class="mfc-textarea-wrapper mfc-form-input-container">
                                        <label for="involveReasonText" class="mfc-label--required">Reason</label>
                                        <textarea id="involveReasonText" name="involveReasonText" required="" ref="delegateassigneetext" maxlength="255" :value="delegateReason" @input=updateReason($event) character-count=""></textarea>
                                        <div class="mfc-invalid-feedback"></div><div class="mfc-help-text mu-mt-00">
                                            
                                        <span>You have {{255 - delegateReason.length}} characters remaining</span>
                                    </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mcc-dialog__footer">

                        <div class="mcc-button-group mcc-button-group--spaced">
                            <button type="button" class="mcc-button mcc-button--outline" @click="delegateCloseHandler()">Cancel</button>
                            <button type="button" class="mcc-button mcc-button--primary" @click="delegateSubmit($event)">Set assignee</button>
                        </div>
                    </div>
                </section>
            </form>
        </dialog>
    </div>
    <div class="mcc-dialog-overlay">
        <dialog class="mcc-dialog mcc-dialog--primary mcc-dialog--xs mu-overflow-visible" id="reassignedialog" ref="reassignedialog">
            <form novalidate id="reassignFormId" ref="reassignFormRef">
                <section>
                    <div class="mcc-dialog__header">
                        <h2 class="h4">Select an assignee</h2>
                        <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="reAssignCloseHandler()">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                    </div>
                    <div class="mcc-dialog__body mu-overflow-visible">
                        <div class="mcc-row">
                            <div class="mcc-col">
                                <div style="position:relative">
                                    <div v-if="!updateCall" class="spinner-overlay">
                                        <div class="spinner-background"></div>
                                        <div class="spinner-flex">
                                            <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                                <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                                <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                            </svg>
                                        </div>
                                    </div>
                                    <div class="mfc-slim-select-wrapper mu-position-relative dialogSlimSelect mfc-form-input-container mu-gap-00 input-gap" id="InvolvingselectedIdDiv" v-show="selectUpdated">
                                        <label for="reassigneeSelect" >Assignee</label>
                                        <div id="InvolvingselectedIdDiv"></div>
                                        <select class="mfc-slim-select" aria-label="single_radio_input" id="reassigneeSelect" :value="assignee" @change="assignee = $event.target.value" ref="reassigneeselect" name="assignee" block>
                                            
                                        </select>
                                    </div>

                                    <div class="mfc-textarea-wrapper mfc-form-input-container">
                                        <label for="reAssignText" class="mfc-label--required">Reason</label>
                                        <textarea id="reAssignText" name="involveReasonText" maxlength="255" ref="reAssignText" required="true" :value="assigneeReason" @input="updateReassignReason($event)" character-count=""></textarea>
                                        <div class="mfc-invalid-feedback"></div><div class="mfc-help-text mu-mt-00">
                                            
                                        <span>You have {{255 - assigneeReason.length}} characters remaining</span>
                                    </div>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                    <div class="mcc-dialog__footer">
                        <div class="mcc-button-group mcc-button-group--spaced">
                            <button type="button" class="mcc-button mcc-button--outline" @click="reAssignCloseHandler()">Cancel</button>
                            <button type="button" class="mcc-button mcc-button--primary" @click="reassigneeSubmit($event)">Set assignee</button>
                        </div>
                    </div>
                </section>
            </form>
        </dialog>
    </div>
</div>
</template>

<script>
import MyTaskListAPI from "@/services/MyTaskListAPI";
import constantMessages from "@/messages";
import {
    EventBus
} from "@/services/event-bus";
import {
    handleFormValidation,
    validationMessages,
    displayErrorMessage
} from '@/formvalid.js';

export default {
    props: ['taskId', 'users', 'taskObj', 'routerURL'],
    data() {
        return {
            taskEventData: [],
            descRegex: constantMessages.PATTERNS["description"],
            delegateReason: '',
            delegateAssignee: '',
            assigneeReason: '',
            assignee: '',
            selectUpdated: false,
            updateCall: true,
            filteredUserList: [],
            AssigneeField: null,
            reassignefield: null
        }
    },
    mounted() {
        this.AssigneeField = new SlimSelect({
            select: '#assigneeField',
            settings: {
                contentPosition: 'absolute',
                contentLocation: document.getElementById('InvolvingselectIdDiv')
            }
        })

        this.reassignefield = new SlimSelect({
            select: '#reassigneeSelect',
            settings: {
                contentPosition: 'absolute',
                contentLocation: document.getElementById('InvolvingselectedIdDiv')
            }
        });
    },
    methods: {
        updateReason(event) {
            let self = this;   
            self.delegateReason = event.target.value;
        },
        updateReassignReason(event) {
            let self = this;
            self.assigneeReason = event.target.value;
        },
        delegateSubmitShowHandler() {
            this.delegateShowHandler()
            this.$refs.delegatedialog.show();
            this.$refs.delegateFormRef.classList.remove('ms-was-validated');
        },
        reAssignSubmitShowHandler() {
            this.reassigneeShowHandler()
            this.$refs.reassignedialog.show();
            this.$refs.reassignFormRef.classList.remove('ms-was-validated'); 
               },
        delegateCloseHandler() {
            this.delegateAssignee = "";
            this.delegateReason = "";
            this.AssigneeField.setSelected('')
            this.$refs.delegatedialog.close()
        },
        reAssignCloseHandler() {
            this.assignee = ""
            this.assigneeReason = ""
            this.reassignefield.setSelected('')
            this.$refs.reassignedialog.close()
        },
        delegateShowHandler() {
            this.filterUsersForDialog()
            this.updateSlimSelectOptions(this.AssigneeField)
            this.selectUpdated = true;
        },
        filterUsersForDialog() {
            let self = this;
            this.filteredUserList = this.users.filter(a => {
                return a.username != self.taskObj.assignee
            });

        },
        reassigneeShowHandler() {
            this.filterUsersForDialog()
            this.updateSlimSelectOptions(this.reassignefield)
            this.selectUpdated = true;
        },
        performDelegateReassigneeOperation(e, operationType) {
            let self = this;
            self.updateCall = false;
            let obj = {
                'taskName': this.taskObj.taskName,
                'processId': this.taskObj.processId,
                'processInstanceId': this.taskObj.processInstanceId,
                'assignee': (operationType == 'delegate') ? this.delegateAssignee : this.assignee,
                'involveReasonText': (operationType == 'delegate') ? this.delegateReason : this.assigneeReason,
                'processName': this.taskObj.processName
            }
            let isError = false;
            MyTaskListAPI.delegateReassigneeTask(this.taskId, obj, operationType)
                .then(response => {
                    if (response.error) {
                        if (response.message == "application.form.delegate.error.email" || response.message == "application.form.reassign.error.email") {
                            EventBus.$emit("warning-notification", {
                                msg: constantMessages.MESSAGES[response.message]
                            });
                        } else {
                            EventBus.$emit("error-notification", {
                                msg: constantMessages.MESSAGES[response.message]
                            });
                            isError = true;
                        }
                    } else {
                        EventBus.$emit("success-notification", {
                            msg: constantMessages.MESSAGES[response.message]
                        });
                    }
                })
                .finally(() => {
                    self.updateCall = true;
                    this.$refs.delegatedialog.close();
                    this.$refs.reassignedialog.close();
                    if (!isError) {
                        self.$router.push(self.routerURL);
                    }
                });
        },
       
        updateSlimSelectOptions(slimInstance) {
      const options = [
        { text: '', placeholder: true },
        ...this.filteredUserList.map((user) => ({ text: user.firstName, value: user.username })),
      ];
      slimInstance.setData(options);
    },
        delegateSubmit(e) {

      
            let form = $('#delegateFormId')

            if (!form[0].checkValidity()) {
                handleFormValidation(form, validationMessages);
                return;
            }

            this.performDelegateReassigneeOperation(e, 'delegate');
        },
        reassigneeSubmit(e) {
            

            let form = $('#reassignFormId')

            if (!form[0].checkValidity()) {
                handleFormValidation(form, validationMessages);
                return;
            }

            this.performDelegateReassigneeOperation(e, 'reassign');
        },
        fetchUsers() {
            let arrayOptions = [];
            let option = {
                text: '',
                placeholder: true
            };
            arrayOptions.push(option);
            $.each(this.users, function (i, obj) {
                let option = {
                    text: obj.firstName,
                    value: obj.username
                };
                arrayOptions.push(option);
            });
            return arrayOptions;
        }
    }
}
</script>
